module.exports = __webpack_public_path__ + "img/8. Процедурный кабинет1.2b350f1d.jpg";